// Root
const root = '/';

// Public routes
const invitation = '/i/';
const login = '/login/';
const logout = '/logout/';
const passwordReset = '/password-reset/';
const registration = '/registration/';
const notificationUnsubscribe = '/notification-unsubscribe/';
// Převzetí tokenu z admin back-office (impersonate) — token v URL fragmentu
const impersonate = '/impersonate/';
// Welcome stránka předregistrovaného SVJ (partnerský program) — token pozvánky v cestě
const welcome = '/welcome/';

// Authenticated routes
const building = '/building/';
const dashboard = '/';
const feed = '/feed/';
const files = '/file-storage/';
const notifications = '/notifications/';
const poll = '/poll/';
const profile = '/profile/';
const units = '/units/';
const subscriptionOrder = '/subscription/';
const registry = '/registry/';
const deadlines = '/deadlines/';
const issues = '/issues/';
const otherServices = '/otherServices/';

// Dev routes
const mockApiExample = '/mock/';
const playground = '/playground/';

export default {
  building: building,
  dashboard: dashboard,
  feed: feed,
  files: files,
  impersonate: impersonate,
  invitation: invitation,
  welcome: welcome,
  login: login,
  logout: logout,
  mockApiExample: mockApiExample,
  notifications: notifications,
  notificationUnsubscribe: notificationUnsubscribe,
  passwordReset: passwordReset,
  playground: playground,
  poll: poll,
  profile: profile,
  registration: registration,
  root: root,
  units: units,
  subscriptionOrder: subscriptionOrder,
  registry: registry,
  deadlines: deadlines,
  issues: issues,
  otherServices: otherServices,
};
